import { render, staticRenderFns } from "./RoomConsumes.vue?vue&type=template&id=23692fd8&"
import script from "./RoomConsumes.vue?vue&type=script&lang=js&"
export * from "./RoomConsumes.vue?vue&type=script&lang=js&"
import style0 from "./RoomConsumes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports